import { render, staticRenderFns } from "./GroupView.vue?vue&type=template&id=7e789f9f&scoped=true"
import script from "./GroupView.vue?vue&type=script&lang=js"
export * from "./GroupView.vue?vue&type=script&lang=js"
import style0 from "./GroupView.vue?vue&type=style&index=0&id=7e789f9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e789f9f",
  null
  
)

export default component.exports